import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Alert from "react-s-alert";
import { NavLink } from "react-router-dom";
//import VendorEditProfileNavigation from "../editProfileScreen/VendorEditProfileNavigation";
import SVG from "react-inlinesvg";
import SocketContext from "../../../function/SocketContext";
import {
  // create_chat_vendor_user,
  get_multiple_chat_vendor_user,
  // get_single_chat_vendor_user,
  // update_mark_all_chat_vendor_user,
} from "../../../store/actions/notificationAction/notificationActions";
import { IconAndTitleLeftNav } from "./UtilitiesLeftNav";

const ChatNavigation = ({ pathname, socket }) => {
  const dispatch = useDispatch();
  const [chatCount, setChatCount] = useState(0);
  const auth = useSelector((state) => state.auth);
  const vendorAccess = useSelector((state) => state.vendorAccess);
  const multiChat = useSelector(
    (state) => state.notifications?.multipleChatInfo
  );
  // const singleChat = useSelector(state => state.notifications?.chatInfo);

  useEffect(() => {
    if (!multiChat || multiChat?.length === 0)
      dispatch(
        get_multiple_chat_vendor_user(
          vendorAccess?.vendor_id || auth.user.VendorUser._id,
          auth.user.accessToken
        )
      );
  }, [vendorAccess?.vendor_id, auth?.user?.accessToken]);

  // useEffect(()=>{
  //   socket.service("chat").on("created", async (data) => {
  //     let dataObj = {
  //       message: data.message,
  //       date: data.createdAt,
  //       read: data.read,
  //       sentBy: data.sentBy,
  //       id: data._id,
  //     };
  //     console.log(data, '*******')
  //     // dispatch({ type: UPDATE_CHAT_INFO, payload: dataObj });
  //   });
  //   dispatch(get_multiple_chat_vendor_user(auth.user.VendorUser._id, auth.user.accessToken))
  // },[]);

  useEffect(() => {
    if (multiChat?.length) {
      let unRead = 0;
      multiChat.forEach((chat) => {
        chat.messages.forEach((msg) => {
          if (
            msg.read === false &&
            (msg.sentBy === "USER" || msg.sentBy === "ADMIN")
          ) {
            // console.log('msg.read, msg.sentBy :>> ', msg.read, msg.sentBy);
            unRead += 1;
          }
        });
      });
      setChatCount(unRead);
    }
  }, [multiChat]);

  return (
    <li
      className={`${
        pathname && pathname === "/chat-dashboard" ? "selected" : ""
      }`}
    >
      <NavLink
        exact
        to="/chat-dashboard"
        title="Chat"
        className="dropdown-toggle btn btn-link"
      >
        <IconAndTitleLeftNav
          icon={require("../../../assets/images/Menu/vendor/chat.svg")}
          title={<>Chat</>}
        />
        {/* <SVG
          src={require("../../../assets/images/Menu/vendor/chat.svg")}
          className="navigation-icon"
          alt="navigation logo"
        /> */}
        <span className="badge bg-danger text-white position-absolute">
          {chatCount}
        </span>
      </NavLink>
    </li>
  );
};

const ChatNavi = (props) => (
  <SocketContext.Consumer>
    {(socket) => <ChatNavigation {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default ChatNavi;
